import styled from 'styled-components'
import { device } from '@/common/constants/device'
import LoadingSpinner from '@/components/common/LoadingSpinner'

export const ProfileModalTitle = styled.div`
  font-size: ${(props) => `${props.fontSizeMobile}px`};
  line-height: 1.2em;
  color: ${(props) => (props.color ? `var(--${props.color})` : 'var(--white)')};
  font-weight: 600;

  @media ${device.tablet} {
    font-size: 24px;
    line-height: 1.2em;
  }
`

export const ProfileTitle = styled.div`
  font-size: 20px;
  line-height: 1.2em;
  font-weight: 800;

  @media ${device.tablet} {
    font-size: 26px;
    line-height: 1.2em;
  }
`

export const ProfileLabel = styled.div`
  font-size: 16px;
  line-height: 1.2em;
  font-weight: 700;
`

export const ProfileText = styled.div`
  font-size: 14px;
  line-height: 1.2em;
  color: var(--tertiary);

  @media ${device.tablet} {
    font-size: 16px;
    line-height: 1.2em;
  }
`

export const ProfileLeft = styled.div`
  padding: 20px;
  background-color: var(--white);
  box-shadow: 0px 141px 85px rgba(27, 27, 68, 0.01),
    0px 63px 63px rgba(27, 27, 68, 0.02), 0px 16px 35px rgba(27, 27, 68, 0.02),
    0px 0px 0px rgba(27, 27, 68, 0.02);
  border-radius: 24px;

  @media ${device.laptop} {
    padding: 24px 32px;
    padding-bottom: 48px;
  }
`

export const ProfileContentWrap = styled.div`
  margin-top: 18px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px 12px;

  @media ${device.laptop} {
    grid-template-columns: ${({ layout }) =>
      layout || '1fr minmax(400px, 0.52fr)'};
  }
`

export const ProfilePreloaderWrap = styled(ProfileContentWrap)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 350px;
`

export const ProfilePreloader = styled(LoadingSpinner)`
  width: 80px;
  height: 80px;

  &::after {
    width: 80px;
    height: 80px;
  }

  @media ${device.tablet} {
    width: 120px;
    height: 120px;

    &::after {
      width: 120px;
      height: 120px;
    }
  }
`

export const ProfileHistoryWrap = styled(ProfileContentWrap)`
  padding: 20px 20px 24px;
  background-color: var(--white);
  border-radius: 24px;

  @media ${device.tablet} {
    padding: 24px 32px 32px;
  }
`

export const ProfilePreloaderBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  height: 100%;

  @media ${device.tablet} {
    min-height: 250px;
  }
`
